const handler = ( $ ) => {
	const $storyBlade = $( '.story-blade' ),
		$nextBlock = $storyBlade.parents().next();

	if (
		$nextBlock.find( 'single-flair-top-wave-block' ) != 0 ||
		$nextBlock.find( 'single-flair-bottom-wave-block' ) != 0 ||
		$nextBlock.find( 'double-flair-top-wave-block' ) != 0 ||
		$nextBlock.find( 'double-flair-bottom-wave-block' ) != 0
	) {
		$storyBlade.addClass( 'story-blade--padding-bottom_40' );
	}
};

( ( $ ) => {
	$( handler );
} )( jQuery );
